import { FC, useState } from 'react';
import { Grid, TextField, Button, Autocomplete, CircularProgress, Box, Typography } from '@mui/material';
import { AvaStore } from '@models';
import { useGetStoresListNoCacheQuery } from '@services';
import { AvaDepotView } from './AvaDepotView';
import { AvaStoresListDownloadCsv } from './AvaStoresListDownloadCsv';
import AvaStoresListUploadCsvModal from './AvaStoresListUploadCsvModal';

const AvaDepotHours: FC = () => {
  const [searchDepotKey, setSearchDepotKey] = useState('');
  const [searchDepot, setSearchDepot] = useState('');
  const { data, isLoading } = useGetStoresListNoCacheQuery();
  const [isCsvUploadModalOpen, setCsvUploadModalOpen] = useState(false);

  if (isLoading)
    return (
      <Box sx={{ height: '100vh' }} display="flex" alignItems="center" justifyContent="center" data-testid="ava-loader">
        <CircularProgress color="inherit" size={75} />
      </Box>
    );

  return (
    <>
      <Grid container alignItems="center" spacing={2} p={2}>
        <Grid item xs={10}>
          <Autocomplete
            id="store-search"
            data-testid="get-store-searchbar"
            onChange={(e: any, newValue: AvaStore | null) => {
              setSearchDepotKey(newValue?.store_code ?? '');
            }}
            options={data || []}
            getOptionLabel={(option) => `${option?.name} ${option?.store_code}` ?? ''}
            disablePortal
            renderInput={(params) => <TextField {...params} label="Search by store name or store code" />}
          />
        </Grid>
        <Grid item>
          <Button variant="contained" type="submit" onClick={() => setSearchDepot(searchDepotKey)} data-testid="get-store-button">
            Search
          </Button>
        </Grid>
      </Grid>
      {searchDepot !== '' && <AvaDepotView searchDepot={searchDepot} />}
      <>
        {data && (
          <Grid border="1px solid" p={2} alignItems="center" marginTop={3}>
            <Grid item xs={10}>
              <Typography variant="body1" p={2}>
                To modify the stores list :
              </Typography>
              <Typography variant="body2">1. Download the existing list via the "Download Stores List" Button.</Typography>
              <Typography variant="body2">2. Open CSV using Excel or Numbers.</Typography>
              <Typography variant="body2">
                3. To add stores - add a row to the bottom of the CSV file and add data for the new store.
              </Typography>
              <Typography variant="body2">4. To Remove Stores - delete the row from CSV file for that store.</Typography>
              <Typography variant="body2">5. Save the file.</Typography>
              <Typography variant="body2">6. Upload the updated CSV file to the input below.</Typography>
            </Grid>
            <Grid item xs={10} p={2}>
              <Typography variant="body2" sx={{ textDecoration: 'underline' }}>
                Download Stores List
              </Typography>
              <AvaStoresListDownloadCsv rows={data} data-testid="ava-stores-list-download-csv-btn" />
            </Grid>
            <Grid item xs={10} p={2}>
              <Typography variant="body2" sx={{ textDecoration: 'underline' }}>
                Upload Updated List
              </Typography>
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                onClick={() => setCsvUploadModalOpen(true)}
                data-testid="ava-stores-list-upload-csv-btn"
              >
                Upload CSV
              </Button>
              <AvaStoresListUploadCsvModal isOpen={isCsvUploadModalOpen} onClose={() => setCsvUploadModalOpen(false)} />
            </Grid>
          </Grid>
        )}
      </>
    </>
  );
};

export default AvaDepotHours;
